import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const MID_BG =
  "https://images.unsplash.com/photo-1758875570120-e156041a857a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxjb3VwbGUlMjB3b3JraW5nJTIwb3V0JTIwZ3ltfGVufDB8fHx8MTc3NzE1ODk5Nnww&ixlib=rb-4.1.0&q=85";

const MidCTA = () => {
  return (
    <section
      data-testid="mid-cta-section"
      className="relative py-32 md:py-44 overflow-hidden"
    >
      <img
        src={MID_BG}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-[#0A0A0A]/85" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/60 to-transparent" />

      <div className="relative container mx-auto max-w-7xl px-6 md:px-10 text-center">
        <p className="text-xs uppercase tracking-[0.35em] text-[#C6FF00] font-semibold mb-6">
          The Real Connection
        </p>
        <h2 className="font-heading text-5xl md:text-7xl lg:text-[8rem] text-white leading-[0.9] max-w-5xl mx-auto">
          YOUR NEXT REP
          <br />
          COULD BE
          <br />
          <span className="text-[#C6FF00]">YOUR PERSON.</span>
        </h2>

        <Link
          to="/register"
          data-testid="mid-cta-join-btn"
          className="group mt-12 inline-flex items-center gap-2 bg-[#C6FF00] hover:bg-[#AEE600] text-[#0A0A0A] font-bold text-base uppercase tracking-[0.2em] px-10 py-5 rounded-md transition-all duration-300 hover:scale-105 shadow-[0_0_30px_rgba(198,255,0,0.4)] hover:shadow-[0_0_60px_rgba(198,255,0,0.6)]"
        >
          Join Now
          <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </section>
  );
};

export default MidCTA;
